import { Map } from 'immutable';
import 'prop-types';
import '@dbh/hotels-types';
import withConformsTo from '@dbh/with-conforms-to-for-production-www';

/**
 * Returns the `GA4` native `view_item_list` event in `analyticsEventSent`
 * format, for hotel packages shown in `HdpPage`.
 * @param {Object} options .
 * @param {Immutable.List<Immutable.Map>} options.hotelPackages .
 * @param {Immutable.Map} options.searchContext .
 * @return {Immutable.Map} .
 * @see {@link https://developers.google.com/analytics/devguides/collection/ga4/reference/events?sjid=10203824956579507532-EU&client_type=gtag#view_item_list_item}
 */const createAnalyticsEventViewItemListHdp=withConformsTo("createAnalyticsEventViewItemListHdp",[],a=>{let{hotelPackages:b}=a;return Map({eventPastTense:"view_item_list",items:b.map(a=>{var b;const c=a.getIn(["bookingAttributes","canBeBooked"]),d=a.getIn(["prices","actual"]),e=a.getIn(["prices","night"]),f=![null,void 0].includes(e),g=f?e-d:void 0;return Map({// We can't guaruantee that the `item_id` we set in
// `@dbh/create-analytics-event-view-item-list` are not the same
// as these, therefore we add a suffix, not to confuse `GA4`.
item_id:a.getIn(["packageAttributes","id"])+"-hp",item_name:a.getIn(["packageAttributes","name"]),index:a.get("ordinal"),...(null==(b=a.getIn(["packageAttributes","packageCategories"]))?void 0:b.reduce((a,b,c)=>4<c?a:(a["item_category"+(0===c?"":c+1)]=b.get("reference"),a),{})),...(c?{price:d,...(g?{discount:g}:{})}:{}),quantity:c?1:0})})})});

export { createAnalyticsEventViewItemListHdp as default };
